const FAMILY_NAME_FIRST_LOCALES = new Set(['hu']);

export function isFamilyNameFirstLocale(locale: string): boolean {
  return FAMILY_NAME_FIRST_LOCALES.has(locale);
}

export function formatFullName(firstname: string, lastname: string, locale: string): string {
  const parts = isFamilyNameFirstLocale(locale) ? [lastname, firstname] : [firstname, lastname];

  return parts.filter(Boolean).join(' ');
}
